export const T = {
  en_GB: {
    productsRemovedWarning: "Products removed (not available on the selected platform): ",
    modelSelectionsResetWarning:
      "Picked model portfolio returned to Automatic (not available on the selected platform): ",
  },
  nb_NO: {
    productsRemovedWarning: "Produkter fjernet (ikke tilgjengelig på valgt plattform): ",
    modelSelectionsResetWarning:
      "Valgt modellportefølje satt tilbake til Automatisk (ikke tilgjengelig på valgt plattform): ",
  },
} as const;
